import { ChangeDetectionStrategy, Component, Input, output, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { LocaleService } from '@next/core-lib/i18n';
import { FertilizationBalanceSetting, LabResultReceiveDates, SamplesBy, SpecificReferenceBlock } from 'src/app/shared/models';

import { EditFertilizationBalanceSettingsDialogHelper } from '../edit-fertilization-balance-settings-dialog.helper';

@Component({
  selector: 'app-fertilization-balance-setting-detail',
  templateUrl: './fertilization-balance-setting-detail.component.html',
  styleUrls: ['./fertilization-balance-setting-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FertilizationBalanceSettingDetailComponent {
  private readonly locale = inject(LocaleService);

  @Input() dataSource: FertilizationBalanceSetting[] = [];
  @Input() formGroupByAdviceId: { [adviceId: number]: FormGroup } = {};

  editSpecificReferenceBlock = output<FertilizationBalanceSetting>();
  samplesByKeys = Object.keys(SamplesBy);

  displayedColumns: string[] = [
    'cropAdviceName',
    'participate',
    'samplesBy',
    'expectedCropYieldProduct',
    'specificReferenceBlock',
    'participationMailDate',
    'externalOrderId',
    'orderDate',
    'cancel',
    'cancellationDate',
  ];

  getFormControl(adviceId: number, controlName: string): FormControl {
    return this.formGroupByAdviceId[adviceId]?.get(controlName) as FormControl;
  }

  getWarningLabelTranslation(translationCode: string): string {
    return this.locale.translate('fertilizationBalance.validation.' + translationCode);
  }

  hasSpecificReferenceBlockData(block?: SpecificReferenceBlock): boolean {
    return EditFertilizationBalanceSettingsDialogHelper.hasSpecificReferenceBlockData(block);
  }

  hasGpsCoordinates(block?: SpecificReferenceBlock): boolean {
    return EditFertilizationBalanceSettingsDialogHelper.hasGpsCoordinates(block);
  }

  hasLabResultReceiveDates(labResultReceiveDates?: LabResultReceiveDates): boolean {
    return EditFertilizationBalanceSettingsDialogHelper.hasLabResultReceiveDates(labResultReceiveDates);
  }

  isSpecificReferenceBlockLocked(setting: FertilizationBalanceSetting): boolean {
    return EditFertilizationBalanceSettingsDialogHelper.isSpecificReferenceBlockLocked(setting);
  }
}
